import { zeroNetwork as viemZeroNetwork } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const zeroNetwork = {
  displayName: 'ZERϴ Network',
  runtime: 'evm',
  viemChain: viemZeroNetwork,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'zero' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
